@if (locationBlocked && !isQA) {
  <p-dialog header="Ubicación requerida" [visible]="true" [modal]="true" [style]="{width: '420px'}" [closable]="false">
    <div class="space-y-3">
      <div class="flex items-center gap-3">
        <i class="pi pi-map-marker text-2xl text-red-500"></i>
        <p class="text-sm text-vivid-royal-700 dark:text-dark-khaki-50">
          Por razones de seguridad debe aceptar la ubicación para utilizar nuestro portal.
          Acepte el acceso a ubicación y refresque la página.
        </p>
      </div>
      <p class="text-xs text-vivid-royal-400">Si requiere más información comuníquese con atención al cliente.</p>
    </div>
  </p-dialog>
}

<p-toast position="top-center" />

<div class="flex h-screen w-full overflow-hidden bg-white ">
  <!-- Loader overlay -->
  @if (inProcess) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <app-loader [message]="'Autenticando'"></app-loader>
    </div>
  }

  <!-- Left: Background image -->
  <div class="relative hidden w-3/5 md:block">
    <img
      src="./assets/monedero.jpg"
      class="absolute inset-0 h-full w-full object-cover"
      alt="Banner"
    />
    <div
      class="absolute inset-0 bg-gradient-to-t from-vivid-royal-950 via-vivid-royal-950/40 to-transparent"
    ></div>
  </div>

  <!-- Right: Login form -->
  <div
    class="flex w-full flex-col items-center justify-center px-6 md:w-2/5 md:px-12 lg:px-20"
  >
    <!-- Logo -->
    <div class="mb-10 animate-fade-in mt-10">
      <img
        src="./assets/logos/energo_logo.svg"
        class="mx-auto w-48 md:w-56 dark:hidden"
        alt="Logo"
      />
      <img
        src="./assets/logos/energo_logo_dark.svg"
        class="mx-auto w-48 md:w-56 hidden dark:block"
        alt="Logo"
      />
    </div>

    <!-- Welcome -->
    <div class="mb-8 text-center animate-fade-in-delay">
      <h1
        class="text-2xl font-semibold text-vivid-royal-500 dark:text-white md:text-3xl"
      >
        Bienvenido
      </h1>
      <p class="mt-2 text-sm text-gray">
        Ingresa tus credenciales para continuar
      </p>
    </div>

    <!-- Form -->
    <form
      [formGroup]="loginForm"
      (ngSubmit)="submit()"
      class="w-full max-w-sm animate-fade-in-delay-2"
    >
      <p-floatlabel variant="on">
        <div class="relative w-full">
          <i class="pi pi-user absolute left-3 top-1/2 -translate-y-1/2 text-gray/50 z-10 text-sm"></i>
          <p-inputnumber
            formControlName="clientNumber"
            inputId="clientNumber"
            [useGrouping]="false"
            [maxlength]="7"
            [min]="1"
            [max]="9999999"
            autocomplete="off"
            styleClass="w-full"
            inputStyleClass="w-full !pl-10" />
        </div>
        <label for="clientNumber">No. de cliente</label>
      </p-floatlabel>
      @if (clientNumber!.touched && clientNumber!.errors?.["required"]) {
        <small class="text-red-500 text-xs mt-1 block">El No. de Cliente es requerido</small>
      }

      <!-- Password -->
      <div class="mt-5 mb-5">
        <p-floatlabel variant="on">
          <div class="relative w-full">
            <i class="pi pi-lock absolute left-3 top-1/2 -translate-y-1/2 text-gray/50 z-10 text-sm"></i>
            <p-password
              formControlName="passkeyClient"
              inputId="passkeyClient"
              [toggleMask]="true"
              [feedback]="false"
              styleClass="w-full"
              inputStyleClass="w-full !pl-10" />
          </div>
          <label for="passkeyClient">Contraseña</label>
        </p-floatlabel>
        @if (passkeyClient!.touched && passkeyClient!.errors?.["required"]) {
          <small class="text-red-500 text-xs mt-1 block">La contraseña es requerida</small>
        }
      </div>

      <!-- Update password button -->
      @if (showButtonUpdate) {
        <button
          type="button"
          (click)="goto('recuperar', false)"
          class="mb-3 w-full rounded-xl border-2 border-medium_purple bg-transparent py-2.5 text-sm font-medium text-medium_purple transition-colors hover:bg-medium_purple hover:text-white"
        >
          Renovar contraseña
        </button>
      }

      <!-- Submit -->
      <p-button
        type="submit"
        label="Ingresar"
        [disabled]="
          inProcess ||
          latitude == null ||
          longitude == null ||
          loginForm.invalid ||
          !isConfigReady
        "
        styleClass="w-full"
        severity="primary"
      />

      <!-- Links -->
      <div class="mt-6 flex flex-col items-center gap-2">
        <button
          type="button"
          (click)="goto('recuperar', true)"
          class="text-sm text-medium_purple transition-colors hover:text-dark_purple hover:underline"
        >
          Generar / Recuperar contraseña
        </button>
        
      </div>
    </form>

    <!-- Footer -->
    <p class="mt-auto pb-6 text-xs text-gray/40">
      &copy; {{ currentYear }} Monedero ENER-GO
    </p>
  </div>
</div>

<!-- 2FA Modal -->
@if (show2FA) {
  <app-auth-code-form
    [phoneNumber]="userPhone"
    [clientNumber]="this.clientNumber!.value"
    [password]="this.passkeyClient!.value"
    (closeModal)="validateOTP($event)"
    (resendLogin)="resendLoginCodeMovil()"
  >
  </app-auth-code-form>
}
